module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M10.61 8H14v9c0 .55.448 1 1 1h2c.552 0 1-.45 1-1V8h3.39c.594 0 .788-.53.43-1L16.646.356c-.356-.47-.936-.478-1.292-.008L10.18 7c-.358.472-.164 1 .43 1zM30 14h-7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h5v6h-7a1 1 0 0 0-1 1v2a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-2a1 1 0 0 0-1-1H4v-6h5a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H2c-1.106 0-2 .894-2 2v14c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V16c0-1.106-.894-2-2-2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/upload-inbox-1.js
// module id = 1485
// module chunks = 14